// removed by extract-text-webpack-plugin
module.exports = {"keyboard_navigation_jump":"SectionHeading--keyboard_navigation_jump--2IpIk","esdp_section_heading":"SectionHeading--esdp_section_heading--3peSX","esdp_section_heading_image":"SectionHeading--esdp_section_heading_image--3d4xk","heading":"SectionHeading--heading--2Vll7"};


//////////////////
// WEBPACK FOOTER
// /src/~/@healthwise/enhanced-shared-decision-point/components/SectionHeading/SectionHeading.css
// module id = 1032
// module chunks = 0